import React, { Fragment } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import NucleusLogo from '../../../assets/Images/nUCLeus_logo.jpg';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  image_logo: {
    backgroundImage: `url(${NucleusLogo})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    // backgroundColor:
    //   theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    // backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100px',
    width: '230px'

  },
}));

const CodeVerification = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <div style={{ height: '50px' }} />
      <Grid item className={classes.image_logo} />
      <div style={{ height: '50px' }}>
        <Typography variant="h4" style={{ textAlign: 'left' }} component="h2" gutterBottom>
          Code Verification
                </Typography>
      </div>
      <form onSubmit="" className={classes.form}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="code"
          label="Code"
          name="code"
          type="number"
          autoFocus
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Submit
            </Button>
        <Grid container justifyContent="center">
          <Grid item>
            <Link to="/login" variant="body2">
              {"Return to Login."}
            </Link>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  );
}

export default CodeVerification;